// @material-ui/core
import { CardActions, IconButton, Menu, MenuItem } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import { MoreVert as MoreVertIcon } from "@material-ui/icons";
import React, { Component } from "react";
import { NavLink } from "react-router-dom";

const ITEM_HEIGHT = 48;

const styles = themes => ({
  root: {
    width: "35px",
    height: "35px"
  },
  colorPrimary: { color: "rgba(0, 0, 0, 0.35)" }
});
class itemCardActions extends Component {
  state = {
    isOpen: null
  };

  handleClick = event => {
    this.setState({ isOpen: event.currentTarget });
    this.props.handleClick(event);
  };

  handleClose = () => {
    this.setState({ isOpen: null });
    this.props.handleClose();
  };

  render() {
    const { classes, actions, isOpen } = this.props;
    return (
      <CardActions className="card-actions" disableActionSpacing>
        {actions && (
          <div id="actions">
            <IconButton
              aria-label="More"
              aria-owns={isOpen ? "long-menu" : null}
              aria-haspopup="true"
              onClick={this.handleClick}
              classes={{ root: classes.root }}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={this.state.isOpen}
              open={Boolean(isOpen)}
              onClose={this.handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "auto"
                }
              }}>
              <NavLink
                to={String(actions.view)}
                activeClassName="active"
                className={classes.navLink}>
                <MenuItem key={1} onClick={this.handleClose}>
                  Details
                </MenuItem>
              </NavLink>

              <NavLink
                to={String(actions.edit)}
                activeClassName="active"
                className={classes.navLink}>
                <MenuItem key={2} onClick={this.handleClose}>
                  Edit
                </MenuItem>
              </NavLink>

              <NavLink
                to={String(actions.delete)}
                activeClassName="active"
                className={classes.navLink}>
                <MenuItem key={3} onClick={this.handleClose}>
                  Delete
                </MenuItem>
              </NavLink>
            </Menu>

            {this.props.children}
          </div>
        )}
      </CardActions>
    );
  }
}

export const ItemCardActions = withStyles(styles, { withTheme: true })(
  itemCardActions
);



// WEBPACK FOOTER //
// ./src/library/card/item-card/actions.js